import React from 'react';
import styled from "@emotion/styled";
import { Image } from "antd";
import selectedIcon from '../assets/selected.png'

export interface VocalType {
  index?: number,
  nickname: string,
  avatar_url: string,
  voice_id: string,
  voice_type: string,
  gender: string,
  default_text: string,
}

const VocalSelection = ({ vocal, isSelected, click, index, disabled }: { disabled?: boolean, vocal: VocalType, isSelected: boolean, click: (index: number, vocal: any) => void, index?: number }) => {
  return (
    <Frame style={{ border: isSelected ? "1px solid rgba(255,103,29,1)" : "1px solid #ffffff", cursor: disabled && index !== 0 ? 'not-allowed' : 'default' }} onClick={() => click(index, vocal)}>
      <img alt='' src={selectedIcon} width={20} style={{ position: "absolute", bottom: -1, right: -1, zIndex: 1, display: isSelected ? "inline-block" : "none" }} />
      <Image src={vocal.avatar_url} width={48} preview={false} />
      <DescDiv>
        <TypeName>{vocal.nickname}</TypeName>
        <TypeDesc>{vocal.voice_type}</TypeDesc>
      </DescDiv>
    </Frame>
  );
}

export default VocalSelection;

const Frame = styled.div`
  width: 159px;
  // height: 80px;
  background: #FFFFFF;
  box-shadow: 0 0 10px 0 rgba(0,0,0,0.06);
  padding: 12px;
  display: flex;
  flex-direction: row;
  position: relative;
  /* margin-right: 20px; */
  cursor: pointer;
  border-radius: 2px;
`

const DescDiv = styled.div`
    display: flex;
  flex-direction: column;
  margin-left: 12px;
  justify-content: space-evenly;
`

const TypeName = styled.div`
  font-size: 14px;
  color: #222222;
  line-height: 14px;
  font-weight: 600;
`

const TypeDesc = styled.div`
  font-size: 14px;
  color: #666666;
  line-height: 14px;
  font-weight: 400;
  margin-top: 10px;
`
